export const commonAppSettings = {
  project: {
    name: 'crowdaa-dashboard',
    release: __COMMIT_SHA__,
  },
  contact: {
    email: 'support@crowdaa.com',
  },
  fontAwesome: {
    apiUrl: 'https://api.fontawesome.com',
  },
  theme: {
    appDefaultPrimaryColor: '#ff2d55',
  },
  mmf: {
    registerUrl: 'https://app.mymerchfactory.com/crowdaa-int',
    loginUrl: 'https://app.mymerchfactory.com/login/',
  },
};
